import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'alumni', Record<UrlRegion, UrlEntry>> = {
  alumni: {
    de: 'alumni',
    'de-en': 'alumni',
    es: 'alumni',
    'es-en': 'alumni',
    fr: 'alumni',
    'fr-en': 'alumni',
    gb: 'alumni',
    nl: 'alumni',
    'nl-en': 'alumni',
    pt: 'alumni',
    'pt-en': 'alumni',
    us: 'alumni',
    ww: 'alumni',
  },
};
